import React, { useState, useCallback, Dispatch, SetStateAction } from "react";
import fetch from "unfetch";
import { useLoads } from "react-loads";
import { toast } from "react-toastify";

import {
  Container,
  TextButton,
  Button,
  GridContainer,
  P,
} from "@util/standard";
import { useStore } from "@state/store";
import { TextInput } from "@global";
interface State {
  email?: string;
}
interface Props {
  setShowForget: Dispatch<SetStateAction<boolean>>;
}

export const ForgotPassword = ({ setShowForget }: Props) => {
  const form = React.createRef<HTMLFormElement>();
  const { closeDrawer } = useStore();

  const initialState: State = {
    email: "",
  };

  const [state, setState] = useState<State>(initialState);
  const [resetComplete, setResetComplete] = useState(false);

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    setState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePasswordReset = async () => {
    let data = { email: state.email };

    const res = await fetch(`/api/forgot-password`, {
      method: "POST",
      body: JSON.stringify(data),
    });
    const response = await res.json();

    if (response) {
      if (response.error) {
        toast.error(response.error);
        return;
      }
      if (res.status == 200) {
        setResetComplete(true);
        toast.success(response);
        return;
      }
      toast.error("An error has occurred");

    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    handlePasswordReset();
  };

  const { isPending, isReloading } = useLoads(
    "handleRegister",
    handlePasswordReset as any,
    {
      defer: true,
    }
  );

  return (
    <>
      {resetComplete ? (
        <Container
          height="100%"
          width="80%"
          margin="auto"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <h2>Reset password succesful.</h2>
          <P textAlign="center">
            Please check your inbox for an email containing the password reset link
          </P>

          <TextButton
            underlined
            margin="30px 0 0 0"
            display="inline-block"
            onClick={() => {
              closeDrawer();
              setShowForget(false);
            }}
          >
            Close
          </TextButton>
        </Container>
      ) : (
        <Container
          height="100%"
          width="80%"
          margin="auto"
          justifyContent="center"
          alignItems="center"
        >
          <form onSubmit={e => handleSubmit(e)} ref={form}>
            <h2>Reset Password</h2>

            <GridContainer
              repeat={1}
              tabletRepeat={1}
              mobileRepeat={1}
              rowGap={20}
            >
              <div>
                <TextInput
                  name="email"
                  type="text"
                  required={true}
                  placeholder="Enter Email"
                  onChange={handleInputChange}
                />
              </div>

              <Button margin="30px 0 0 0" type="submit">
                {isPending || isReloading ? "loading" : "Submit"}
              </Button>
              <div>
                Already have an account?{" "}
                <TextButton
                  underlined
                  margin="30px 0 0 0"
                  display="inline-block"
                  onClick={() => setShowForget(false)}
                >
                  Log in
                </TextButton>
              </div>
            </GridContainer>
          </form>
        </Container>
      )}
    </>
  );
};
